export class RecordQantity{
    StudentsInAccount :number =0;
    Cars:number=0;
    StudentsToEdit:number=0;
    DailyRides:number=0;
}